<template>
  <v-text-field
    v-model="search"
    :label="placeholder"
    hide-details
    single-line
    outlined
    dense
  >
    <template v-slot:append>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="mt-1"
            small
            v-bind="attrs"
            v-on="on"
          >
            fas fa-search
          </v-icon>
        </template>
        <span>Buscar en los datos filtrados</span>
      </v-tooltip>
    </template>
  </v-text-field>
</template>

<script>
/**
 * Barra de búsqueda interna para data tables
 */
export default {
  props: {
    value: String, // texto a buscar en el data table
    placeholder: {
      type: String,
      default: 'Buscar'
    }
  },
  computed: {
    search: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>